import DBR from "dynamsoft-javascript-barcode";
DBR.BarcodeReader.organizationID = "100723545";
DBR.BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@8.8.3/dist/";
export default DBR;